import Homepage from './Homepage';
import Reservation from './Reservation';
import Finish from './Finish';

const modules = {
  Homepage,
  Reservation,
  Finish,
}

const App = (function() {
  function _initModules() {
    let ms = Array.from($('[data-module]')).map(elem => $(elem).attr('data-module'));
    console.log(ms)
    ms.forEach(m => {
      modules[m].init();
    });
  }

  function _checkLang() {
    if (!window.location.hash) {
      window.location.href = "#/hu";
    } 
  }

  return {
    init: () => {
      console.log('app init');
      _checkLang();
      _initModules();
    }
  }
})()

export default App;


// WEBPACK FOOTER //
// ./src/App.js